import UseCaseLayout from './UseCaseLayout';
import type { UseCaseData } from './UseCaseLayout';

const data: UseCaseData = {
  title: 'For API providers',
  subtitle:
    'People want to reach your API from Claude and Cursor. Publishing an MCP server means building auth, rate limiting and hosting you did not plan for, or letting Statio run it.',
  art: 'campagna',
  problemTitle: 'You want AI agents to use your API. Building the infra is a project.',
  problemText:
    'You want AI agents to call your API, but you would have to build MCP server hosting, authentication, rate limiting and usage metering from scratch. That is months of infrastructure work that has nothing to do with your core product.',
  solutionTitle: 'Statio is the checkpoint.',
  solutionText:
    'Statio hosts your MCP server, handles authentication and rate limiting, and attributes every call to the person or agent that made it. Give Statio the URL of your OpenAPI spec and you get a live MCP endpoint in minutes.',
  benefits: [
    {
      title: 'Instant MCP endpoint from your OpenAPI spec',
      body: 'Give Statio a spec and mcp-gen generates the server, then Statio builds and hosts it. Choose one tool per endpoint, a generic pattern for very large APIs, or a curated set of tools.',
      href: '/mcp-gen',
      linkLabel: 'About mcp-gen',
    },
    {
      title: 'Already have a server? Bring it',
      body: 'From Team up, hand Statio a Docker image and it runs behind the same gateway, access rules and logs. Or keep hosting it yourself and connect it by URL.',
    },
    {
      title: 'Every call attributed to its caller',
      body: 'Every call through the gateway is counted and attributed to the person or agent that made it, and rate limited by plan.',
    },
    {
      title: 'Metering built in',
      body: 'Calls are metered at the gateway, so usage is measured without you building the meter.',
    },
    {
      title: 'No MCP infrastructure to run or maintain',
      body: 'Statio builds and hosts the server on Google Cloud Run, and hosted servers sleep when idle.',
    },
    {
      title: 'Callers connect with a single key',
      body: 'Each person or agent adds one Statio key to their AI client. Your API credentials are stored encrypted and added inside the gateway at call time, never handed to the client.',
    },
  ],
  otherCases: [
    {
      label: 'For AI agent developers',
      slug: 'developers',
      body: 'Replace the API keys in every agent config with one Statio key, and give each agent its own identity.',
    },
    {
      label: 'For enterprise security',
      slug: 'enterprise',
      body: 'Grant access per tool, keep the record of every call, and revoke any agent on its own.',
    },
  ],
};

export default function ProvidersPage() {
  return <UseCaseLayout data={data} />;
}
